const isObject = (val) => val !== null && typeof val === 'object'

const candidatePaths = [
  ['tender_number'],
  ['tenderNumber'],
  ['tender_plan_id'],
  ['tenderPlanId'],
  ['tenderPlanID'],
  ['tender_planID'],
  ['tender_id'],
  ['tenderId'],
  ['tenderID'],
  ['tp_id'],
  ['tpId'],
  ['tpID'],
  ['tpNumber'],
  ['tender', 'tender_number'],
  ['tender', 'tenderNumber'],
  ['tender', 'tender_plan_id'],
  ['tender', 'tenderPlanId'],
  ['tender', 'tenderPlanID'],
  ['tender', 'tender_id'],
  ['tender', 'tenderId'],
  ['tender', 'tenderID'],
  ['tender', 'tp_id'],
  ['tender', 'tpId'],
  ['tender', 'tpID'],
  ['tender', '_id'],
  ['tender', 'id'],
  ['tender', 'number'],
  ['_id'],
  ['id'],
]

function toIdString(value) {
  if (value == null) return null
  if (typeof value === 'number' && !Number.isFinite(value)) return null
  const str = String(value).trim()
  return str ? str : null
}

function pickByPath(source, path) {
  let current = source
  for (const key of path) {
    if (!isObject(current) && typeof current !== 'function') return null
    current = current?.[key]
    if (current == null) return null
  }
  return current
}

/** Пути для Django API `/api/tenders/<ref>/…` — сначала внутренний id тендера в БД. */
const apiRefPaths = [
  ['backendId'],
  ['tenderId'],
  ['tender_id'],
  ['tender', 'id'],
  ['tender_number'],
  ['tenderNumber'],
  ['tender', 'tender_number'],
  ['tender', 'tenderNumber'],
  ...candidatePaths,
]

export function resolveTenderPlanId(input) {
  if (input == null) return null
  if (!isObject(input)) {
    return toIdString(input)
  }

  for (const path of candidatePaths) {
    const value = pickByPath(input, path)
    const str = toIdString(value)
    if (str) return str
  }

  return null
}

/** Ссылка на тендер для основного API (предпочтительно id в PostgreSQL). */
export function resolveTenderApiRef(input) {
  if (input == null) return null
  if (!isObject(input)) {
    return toIdString(input)
  }

  for (const path of apiRefPaths) {
    const value = pickByPath(input, path)
    const str = toIdString(value)
    if (str) return str
  }

  return null
}

export function ensureTenderPlanId(input) {
  return resolveTenderPlanId(input)
}

export default resolveTenderPlanId
